export default __webpack_public_path__ + "static/media/AUT.d95c3edc.svg";